export { default as webRouter } from './web-router'
export { default as settingRouter } from './setting-router'
export { default as appRouter } from './app-router'



// WEBPACK FOOTER //
// ./src/router/index.js